module.exports = __webpack_public_path__ + "static/media/8.ad9b6b26.jpg";